module.exports = __webpack_public_path__ + "img/geo-alt.e09f8e12.svg";